import React from 'react';

import {
  UsersDetailSection,
  UsersHeaderSection
} from 'modules';
import { Box } from '@mui/material';

export type UsersActivityProps = {};

export const UsersActivity = (props: UsersActivityProps) => {

  return (
    <Box>

      <UsersHeaderSection.FC />
      <UsersDetailSection.FC />
    </Box>

  );
};
